import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../firebase/AuthContext';
import './Start.css';

const Start = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { signInWithGoogle } = useAuth();

  const handleNewUserSignup = () => {
    // 新規登録画面に遷移
    navigate('/regist');
  };

  const handleLogin = () => {
    // ログイン画面に遷移
    navigate('/login');
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      const result = await signInWithGoogle();
      
      // プロフィール設定が必要かチェック
      if (result.needsProfileSetup) {
        navigate('/profile-setup');
      } else {
        navigate('/top');
      }
    } catch (error) {
      console.error('認証エラー詳細:', error);
      
      // ユーザーにエラーを表示
      alert(`認証エラーが発生しました: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTestLogin = () => {
    // 開発環境用：認証をスキップしてTop画面に遷移
    // テストログイン：Top画面に遷移
    navigate('/top');
  };

  return (
    <div className="start-page-container">
      <div className="start-center-box start-login-container">
        <img src="/img/tiny-identity.png" alt="ロゴ" />
        <h1 className="login-title">Tiny identity</h1>
        
        <div className="start-poster-select">
          <div className="start-poster-carousel">
            {/* 最初のセット */}
            <img src="/img/p1.png" alt="poster1" />
            <img src="/img/p2.png" alt="poster2" />
            <img src="/img/p3.png" alt="poster3" />
            <img src="/img/p4.png" alt="poster4" />
            <img src="/img/p5.png" alt="poster5" />
            {/* シームレスループのための複製セット */}
            <img src="/img/p1.png" alt="poster1-copy" />
            <img src="/img/p2.png" alt="poster2-copy" />
            <img src="/img/p3.png" alt="poster3-copy" />
            <img src="/img/p4.png" alt="poster4-copy" />
            <img src="/img/p5.png" alt="poster5-copy" />
          </div>
        </div>

        <p className="login-message">
          「叫びたいこと」、「ちょっと思ったこと」をポスターに。<br />
          そこから広がる世界を楽しもう
        </p>

        <button className="btn-primary" onClick={handleNewUserSignup}>
          新規登録
        </button>
        
        <button className="btn-outline" onClick={handleLogin}>
          ログイン
        </button>

        {/* パスワード忘れリンク */}
        <a 
          className="login-footer-link" 
          href="#" 
          onClick={(e) => {
            e.preventDefault();
            navigate('/forgot-password');
          }}
        >
          パスワードをわすれた方はこちら
        </a>

        {/* 開発環境用テストボタン */}
        {process.env.NODE_ENV === 'development' && (
          <button 
            className="btn-outline" 
            onClick={handleTestLogin}
            style={{ backgroundColor: '#ffeaa7', marginTop: '10px' }}
          >
            🧪 テストログイン（開発用）
          </button>
        )}

        <button className="gsi-material-button" onClick={handleGoogleSignIn}>
          {loading ? (
            <div>認証中...</div>
          ) : (
            <>
              <div className="gsi-material-button-state"></div>
              <div className="gsi-material-button-content-wrapper">
                <div className="gsi-material-button-icon">
                  <svg 
                    version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 48 48" 
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    style={{display: 'block'}}
                  >
                    <path 
                      fill="#EA4335" 
                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                    />
                    <path 
                      fill="#4285F4" 
                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                    />
                    <path 
                      fill="#FBBC05" 
                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                    />
                    <path 
                      fill="#34A853" 
                      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                    />
                    <path fill="none" d="M0 0h48v48H0z" />
                  </svg>
                </div>
                <span className="gsi-material-button-contents">Sign in with Google</span>
                <span style={{display: 'none'}}>Sign in with Google</span>
              </div>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Start;
